var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { observable, action, ObservableMap, makeObservable } from 'mobx';
class NotificationStore {
    constructor() {
        Object.defineProperty(this, "notifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ref) => this.ref = ref
        });
        Object.defineProperty(this, "addNotification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ message: rawMessage = '', level = 'info', dismissible = 'none' }) => {
                // ADV-281: catch blocks pass the caught Error itself (e.g. SettingsPage's
                // `_get(errors, '[0].detail', err)`); react-notification-system renders the message as a
                // React child → "Objects are not valid as a React child (found: [object Error])" → the
                // whole app went white. Show the error's text instead.
                const message = rawMessage instanceof Error ? rawMessage.message : rawMessage;
                const timeStamp = Date.now();
                this.notifications.set(timeStamp, {
                    message,
                    level,
                    dismissible
                });
                // Guard: the notification UI ref may not be mounted yet (e.g. a backend 502 during initial
                // page load fires a notification before setRef runs). Without this guard the null-deref
                // (`Cannot read properties of null (reading 'addNotification')`) crashes the whole page.
                if (this.ref && typeof this.ref.addNotification === 'function') {
                    this.ref.addNotification({
                        message,
                        level,
                        dismissible,
                        uid: timeStamp,
                        title: null
                    });
                }
            }
        });
        makeObservable(this);
    }
}
__decorate([
    observable,
    __metadata("design:type", typeof (_a = typeof ObservableMap !== "undefined" && ObservableMap) === "function" ? _a : Object)
], NotificationStore.prototype, "notifications", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NotificationStore.prototype, "ref", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], NotificationStore.prototype, "setRef", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], NotificationStore.prototype, "addNotification", void 0);
export default new NotificationStore();
